// frontend/src/hooks/useSupplierCategories.js
// Roadmap 3.6 — el array hardcoded SUPPLIER_CATEGORIES se sustituye por el
// catálogo editable del tenant. El estado arranca con las 4 históricas y se
// reemplaza por el catálogo real cuando llega; si el fetch falla, se quedan
// las 4 de siempre — NUNCA un select vacío.
import { useEffect, useState } from "react";
import { apiFetch, API } from "@/utils/api";
import {
  DEFAULT_SUPPLIER_CATEGORIES,
  catalogToNames,
} from "@/utils/supplierCategories";

export function useSupplierCategories() {
  const [categories, setCategories] = useState(DEFAULT_SUPPLIER_CATEGORIES);

  useEffect(() => {
    let cancelled = false;
    apiFetch(`${API}/supplier-categories/catalog`)
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (!cancelled && data) setCategories(catalogToNames(data));
      })
      .catch(() => {
        // Fallback silencioso: las 4 por defecto ya están en el estado.
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return categories;
}

export default useSupplierCategories;
